export default __webpack_public_path__ + "locales/fi/SingleSignOn.json?hash=8163ffd7aecfcf0f0d0206688cd37155";